document.addEventListener('DOMContentLoaded', function () {
    const bgElement = document.querySelector('.js-section-clouds-block__column');
    const imageElement = document.querySelector('.js-section-clouds-block__main-image');

    if (bgElement && imageElement) {
        const bgHeight = bgElement.offsetHeight;
        imageElement.style.maxHeight = `${bgHeight}px`;
    }
});
